import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import DataMasterNumber from "./MasterNumberData";
import { useEffect } from "react";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";

const customStyles = {
  pagination: {
    style: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
};

const columns = [
  {
    name: "DIOD",
    selector: "diod",
    cell: (row) => <div className="fontColor">{row.diod}</div>,
  },
  // {
  //   name: "ASSIGNED COMPANY",
  //   selector: "ASSIGNED_COMPANY",
  //   cell: (row) => <div className="fontColor">{row.ASSIGNED_COMPANY}</div>,
  // },
  // {
  //   name: "Created",
  //   selector: "CREATED",
  // },
  // {
  //   name: "",
  //   cell: (row) => (
  //     <div className="uk-float-right" style={{"text-align": "end", "width": "100%"}}>
  //       <div className="uk-inline">
  //         <button className="iconTble actionDropDownBtn TableActionIcon" type="button">
  //           <img src="./assets/images/zong/trash-can.svg" uk-svg="" alt="Delete" />
  //         </button>
  //         <button className="iconTble actionDropDownBtn TableActionIcon" type="button">
  //           <img src="./assets/images/zong/trash-can.svg" uk-svg="" alt="Delete" />
  //         </button>
  //       </div>
  //     </div>
  //   ),
  // },
];

const MasterNumberDIOD = () => {
  const { auth } = useAuth();
  const [searchText, setSearchText] = useState("");
  const [masterNo, setMasterNo] = useState();

  const navigate = useNavigate();

  const getMasterNo = () => {
    axios
      .post(
        url + "get-diod",
        {},
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          // console.log("res==========>",response);
          // console.log("res==========>",response?.data?.data?.vpbx_diod);
          // console.log("res==========>",response.data.message === "Data Found");
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setMasterNo(response?.data?.data?.vpbx_diod);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    getMasterNo();
  }, []);
  // const handleEditLayer = (row) => {
  //   // console.log("Row data:", row);
  //   navigate("/edit-layer", { state: { rowData: row } });
  // };

  const handleSearchform = (event) => {
    setSearchText(event.target.value);
  };

  const filteredDataMasterNumber = masterNo?.filter((MasterNumberData) => {
    return (
      MasterNumberData.diod &&
      MasterNumberData.diod.toLowerCase().includes(searchText.toLowerCase())
      // ||
      // (MasterNumberData.ASSIGNED_COMPANY && MasterNumberData.ASSIGNED_COMPANY.toLowerCase().includes(searchText.toLowerCase())) ||
      // (MasterNumberData.CREATED && MasterNumberData.CREATED.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handleExportData = () => {
    const exportedData = filteredDataMasterNumber.map((MasterNumberData) => ({
      DIOD: MasterNumberData.diod,
      // "ASSIGNED COMPANY": MasterNumberData.ASSIGNED_COMPANY,
      // "Created": MasterNumberData.CREATED,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," + convertToCSV(exportedData);
    const jsonData = JSON.stringify(exportedData, null, 2);

    const downloadLink = document.createElement("a");
    downloadLink.href = csvContent;
    downloadLink.download = "exported_data.csv";
    downloadLink.click();
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  useEffect(() => {
    if (masterNo !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)"
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [masterNo]);

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>

                <p>
                  Use this page to create company, add packages or add master
                  number.
                </p>
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                <li onClick={() => navigate("/companies", { replace: true })}>
                  <a href="#">Companies</a>
                </li>
                <li onClick={() => navigate("/packages", { replace: true })}>
                  <a href="#">Packages</a>
                </li>
                <li
                  className="uk-active"
                  onClick={() => navigate("/master-number", { replace: true })}
                >
                  <a href="#">Master number DIOD</a>
                </li>
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            <li></li>
            <li></li>
            <li>
              <div className="ImcomingCallMain">
                <div className="uk-grid" uk-grid="">
                  <div className="uk-width-1-2">
                    <div className="uk-text-left">
                      <div className="CustomSearch">
                        <form className="uk-search uk-search-default">
                          <input
                            className="uk-search-input"
                            type="text"
                            placeholder="Search by Diod"
                            value={searchText}
                            onChange={handleSearchform}
                          />
                        </form>
                        {/* <div className="MainHeading">
                <h6>IVR flow</h6>
              </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="uk-width-1-2">
                    <div className="uk-text-right">
                      <span>
                        <div className="uk-inline uk-text-left">
                          <Link
                            className="exportData-button NewFlow"
                            to="/add-master-number"
                          >
                            Add Master number
                          </Link>
                          <button
                            className="exportData-button"
                            onClick={handleExportData}
                          >
                            Export Data
                          </button>
                        </div>
                      </span>
                      <span className="primary-color"></span>
                    </div>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={filteredDataMasterNumber}
                  pagination
                  customStyles={customStyles}
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MasterNumberDIOD;
